"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatRoundedIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const RepeatRoundedIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("path", { d: "M7 7h10v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V5H6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V7zm10 10H7v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.31.31.85.09.85-.36V19h11c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v3z" })));
exports.RepeatRoundedIcon = RepeatRoundedIcon;
exports.default = exports.RepeatRoundedIcon;
